import { handleToast } from '../components/Toast';

export const showZodErrorToast = (errors: any) => {
  Object.values(errors).forEach((error: any) => {
    if (error?.message) {
      handleToast(true, error.message);
    }
  });
};
